import React, { useEffect, useState } from 'react';
import { ClientService } from '../../../../../services/clientService';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import './folderselectionpopup.css';
import ListView from '../../../../../assets/images/Ic_list row.png';
import GrideView from '../../../../../assets/images/Ic_grid.png';
import NoShortlistedImage from '../../../../../assets/images/im_Add Candidate Folder.png';
import ProfileBack from '../../../../../assets/images/Ic_profile_back.png';
import AddFolder from '../../../../../assets/images/Ic_add folder.png';
import CloseIcon from '../../../../../assets/images/Ic_close.png';
import { Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const FolderSelectionPopup = ({
  isFolderSelectionPopupVisible,
  closePopup,
  newFolderName,
  handleProfileSaving,
  getFullName,
  selectedCandidateId,
  selectedClientId,
  selectedFolder,
  shortlistNote,
  setShortlistNote,
  closeback,
  isCustomStructure = false,
}) => {
  const [candidates, setCandidates] = useState([]);
  const [page, setPage] = useState(0);
  const [size] = useState(10);
  const [hasNext, setHasNext] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const fetchShortlistedCandidates = async (pageNo = 0) => {
    setIsLoading(true);
    try {
      if (selectedFolder) {
        const folderId = selectedFolder.folderId;
        if (folderId) {
          const response = await ClientService.getShortlistedCandidates(
            folderId,
            pageNo,
            size
          );
          const shortlists = response.shortlists || [];
          setCandidates(shortlists);
          setHasNext(response.hasNext);
          setPage(pageNo);
          setTotalPages(response.totalPages || 1);
        }
      }
    } catch (error) {
      console.error("Error fetching shortlisted candidates:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isFolderSelectionPopupVisible) {
      if (selectedFolder) {
        fetchShortlistedCandidates(0);
      } else {
        setIsLoading(false);
      }
    }
  }, [isFolderSelectionPopupVisible, selectedFolder]);

  const handleSaveProfile = async () => {
    if (loading) return;
    setLoading(true);

    try {
      await handleProfileSaving(
        selectedCandidateId,
        selectedClientId,
        shortlistNote
      );
    } catch (error) {
      console.error("Error saving profile:", error);
    } finally {
      setLoading(false);
    }
  };


  // Pagination control functions
  const goToFirstPage = () => fetchShortlistedCandidates(0);
  const goToPreviousPage = () => fetchShortlistedCandidates(Math.max(0, page - 1));
  const goToNextPage = () => {
    if (hasNext) {
      fetchShortlistedCandidates(page + 1);
    }
  };
  const goToLastPage = () => {
    if (totalPages > 1) {
      fetchShortlistedCandidates(totalPages - 1);
    }
  };

  if (!isFolderSelectionPopupVisible || !selectedFolder) {
    return null;
  }
  const displayFolderName = selectedFolder.name || newFolderName;
  const handleCandidateSearchResult = () => {
    setLoader(true);
    navigate('/client/candidate-search-result');
  };

  const handleBackClick = () => {
    closeback();
  };

  const handleCloseClick = () => {
    closePopup();
  };

  return (
    <div className="profile-work-experience-popup-overlay position-fixed top-0 start-0 d-flex justify-content-center align-items-center bg-dark bg-opacity-50">
      <div className="profile-work-experience-popup-container bg-white p-4 rounded"
        style={{
          position: 'relative', maxHeight: '90vh',
          overflowY: 'auto',
        }}>

        {isCustomStructure && (
          <>
            <button className="back-button" onClick={handleCloseClick}>
              <img src={CloseIcon} alt="Close" className="register-close-icon" />
            </button>
            <div className="profile-work-experience-popup-header text-center mb-4">
              <h2>Save Candidate in Folder</h2>
            </div>
          </>
        )}
        <div className="profile-work-experience-popup-content">
          {!isCustomStructure && (
            <>
              <div className="profile-work-experience-popup-header text-center mb-4">
                <h2>Please Select The Folder To Shortlist Candidate</h2>
              </div>
              <div className="profile-work-experience-popup-shortlist-as mb-4 d-flex align-items-center">
                <label className="me-2">Shortlist As</label>
                <input type="text" value={getFullName} readOnly className="form-control" />
              </div>
            </>
          )}
          <hr className="profile-work-experience-popup-divider" />
          <div className="profile-work-experience-popup-folders">
            <div className="folders-header d-flex justify-content-between align-items-center">
              <div className="folders-left d-flex align-items-center">
                {!isCustomStructure && (

                  <img src={ProfileBack} alt="Back Icon" className="folder-action-icon" onClick={handleBackClick} style={{ cursor: 'pointer' }} />
                )}
                <h3 className="folders-heading ms-2">{displayFolderName}</h3>
              </div>
              <div className="folders-actions d-flex align-items-center">
                {/* <img src={AddFolder} alt="Create Folder" className="folder-action-icon me-2" />
                <div className="profile-work-experience-popup-vertical-line me-2"></div>
                <img src={ListView} alt="List View" className="folder-action-icon me-2" />
                <img src={GrideView} alt="Grid View" className="folder-action-icon" /> */}
              </div>
            </div>
          </div>
        </div>
        <div className="folder-selection-image-container d-flex flex-column align-items-center">
          {isLoading ? (
            <div className="overlay-spinner">
              {/* Loading spinner */}
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          ) : candidates.length > 0 ? (
            <div className="table-container" style={{ maxHeight: '200px', overflowY: 'auto', marginTop: '20px' }}>
              <table
                className="table"
                style={{ border: '1px solid #F35824', width: '100%', fontSize: '12px', tableLayout: 'fixed', '--bs-table-bg': 'transparent' }}
              >
                <thead>
                  <tr >
                    <th className="folderselection-table-head">Name</th>
                    <th className="folderselection-table-head">Candidate ID</th>
                  </tr>
                </thead>
                <tbody>
                  {candidates.map((candidateWrapper) => {
                    const candidate = candidateWrapper.candidate;
                    const personalDetails = _.get(candidate, 'candidate.personalDetails', {});
                    const firstName = _.get(personalDetails, 'firstName', '');
                    const lastName = _.get(personalDetails, 'lastName', '');
                    const fullName = `${firstName} ${lastName}`.trim();
                    const candidateId = _.get(candidateWrapper, 'candidate.candidateId');
                    return (
                      <tr key={candidateId}>
                        <td style={{ border: '1px solid #F35824' }}>{fullName}</td>
                        <td style={{ border: '1px solid #F35824' }}>{candidateId}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

            </div>
          ) : (
            <>
              <img src={NoShortlistedImage} alt="No Shortlisted Candidate" />
              <p className="no-candidate-text mt-3">No Shortlisted Candidate Added</p>
            </>
          )}
          <div className="pagination-controls mt-3">
            {/* Pagination controls */}
            {candidates.length > 0 && totalPages > 1 && (

              <div className=" justify-center items-center text-center flex  p-1  rounded-lg shadow-md">
                <button
                  onClick={goToFirstPage}
                  disabled={page === 0 || isLoading}
                  className={`pagination-button large-symbol ${page === 0 || isLoading ? ' cursor-not-allowed' : ''}`}
                >
                  &laquo;
                </button>

                <button
                  onClick={goToPreviousPage}
                  disabled={page === 0 || isLoading}
                  className={`pagination-button large-symbol ${page === 0 || isLoading ? ' cursor-not-allowed' : ''}`}
                >
                  &lsaquo;
                </button>

                <span className="pagination-text px-4">
                  {page + 1} of {totalPages || 1}
                </span>
                <button
                  onClick={goToNextPage}
                  disabled={!hasNext || isLoading}
                  className={`pagination-button large-symbol ${!hasNext || isLoading ? ' cursor-not-allowed' : ''}`}
                >
                  &rsaquo;
                </button>
                <button
                  onClick={goToLastPage}
                  disabled={page === totalPages - 1 || totalPages <= 1 || isLoading}
                  className={`pagination-button large-symbol ${page === totalPages - 1 || totalPages <= 1 || isLoading ? ' cursor-not-allowed' : ''}`}
                >
                  &raquo;
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="profile-work-experience-popup-note mt-4">
          <label className="mb-2 fw-semibold">
            Add Note <span className="text-muted fw-normal">(optional)</span>
          </label>

          <textarea
            className="form-control"
            rows={3}
            value={shortlistNote}
            onChange={(e) => setShortlistNote(e.target.value)}
          />
        </div>

        <div className="folderselection-popup-actions d-flex mt-4">
          {isCustomStructure ? (
            <button className="candidate-landing-page-search-btn" type="button" onClick={handleCandidateSearchResult}>
              <FontAwesomeIcon icon={faSearch} className="candidate-landing-page-search-icon" />
              Search Candidate
            </button>
          ) : (
            <>
              <button className="folderselection-popup-cancel" onClick={closePopup}>
                Cancel
              </button>
              <button
                className={`folderselection-popup-yes ${loading ? 'loading' : ''}`}
                onClick={handleSaveProfile}
              >
                {loading ? (
                  <>
                    <Spinner
                      animation="border"
                      role="status"
                      size="sm"
                      style={{ color: '#F35824', marginRight: '8px' }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </>
                ) : (
                  'Yes'
                )}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FolderSelectionPopup;